import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';

import { Link } from '../../common/components/link';
import { OfferStatsPopupContainer } from '../offer_stats_popup/container';
import * as styles from './index.css';

export interface IOfferStats {
  daily: number;
  total: number;
}

export interface IOfferStatsProps {
  isFromBuilder: boolean | null;
  offerStats: IOfferStats | null;
}

export interface IOfferStatsDispatchProps {
  offerStatsPopupOpen(): void;
}

export type IProps = IOfferStatsProps & IOfferStatsDispatchProps;

export class OfferStats extends React.PureComponent<IProps, {}> {
  public render() {
    if (!this.props.offerStats) {
      return null;
    }

    const { daily, total } = this.props.offerStats;

    return (
      <div className={styles['container']}>
        <Link className={styles['link']} onClick={this.handleClick}>
          {numberToPrettyString(total)} {plural(total, ['просмотр', 'просмотра', 'просмотров'])}, {daily} за сегодня
        </Link>
        <OfferStatsPopupContainer />
      </div>
    );
  }

  private handleClick = () => {
    this.props.offerStatsPopupOpen();
  }
}
